//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../no/Builder.js";
import "../no/CollaborativeDesign.js";
import "../no/ContentDefinition.js";
let d=[[[0,"CollaborativeDesign",1,"CollaborativeDesign",0],[0,"ConfigDetail",1,0],[0,"ConfigMode",0,0],[0,"ConfigType",1,0],[0,"ContentDefinition",1,"ContentDefinition",0],[0,"EffectivityTable",0,"PDM.EffectivityTableBuilder",0],[0,"OverrideFolder",1,0],[0,"RevisionRule",1,0],[0,"VariantConfiguration",0,"PDM.VariantConfigurationBuilder",0]],[],[]];
SPLM.PDM.ConfigurationContextBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PDM.ConfigurationContextBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PDM.ConfigurationContextBuilder.ConfigContextMode = Object.freeze({
    "Nx4gd" : "Nx4gd", "Assemblies" : "Assemblies", "ReturnConfigContextDontSetCurrent" : "ReturnConfigContextDontSetCurrent", "CustomConfigContext" : "CustomConfigContext"});

SPLM.PDM.ConfigurationContextBuilder.ConfigContextType = Object.freeze({
    "AsSaved" : "AsSaved", "PushedfromTeamcenter" : "PushedfromTeamcenter", "DefineorLoadContext" : "DefineorLoadContext"});

SPLM.PDM.ConfigurationContextBuilder.ConfigurationDetail = Object.freeze({
    "LoadfromTeamcenter" : "LoadfromTeamcenter", "DefineinNX" : "DefineinNX"});

export default SPLM;